/** The marketing site, for links to partner pages and legal documents. Deployed builds set VITE_SITE_URL. */
export const SITE_URL =
  (((import.meta.env as Record<string, string | undefined>).VITE_SITE_URL ?? "").trim().replace(/\/+$/, "") ||
    "https://www.keydials.com");
